import { render } from "./ResearchPreview.vue?vue&type=template&id=f6e31e4a&scoped=true"
import script from "./ResearchPreview.vue?vue&type=script&lang=js"
export * from "./ResearchPreview.vue?vue&type=script&lang=js"

import "./ResearchPreview.vue?vue&type=style&index=0&id=f6e31e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e31e4a"]])

export default __exports__